/**
 * @Author: 仙道
 * @Date: 2022-06-23 20:51:41
 * @LastEditTime: 2023-05-07 19:35:50
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/store/modules/workbench.js
 **/
import { getAction } from '@/api/manage'
import * as _ from 'lodash'

const defaultLayoutList = [
  { x: 0, y: 0, w: 5, h: 3, i: '0', key: 'menu', id: 0, minH: 2, minW: 4, component: 'QuickMenu' }, //0列0行 宽为3块，高为5*rowHeight
  { x: 2, y: 3, w: 5, h: 3, i: '9', key: 'waterRecord', id: 9, minH: 3, minW: 6, component: 'WaterRecord' },
  { x: 2, y: 3, w: 5, h: 3, i: '10', key: 'violationRecord', id: 10, minH: 3, minW: 6, component: 'ViolationRecord' }, //违规记录
  { x: 1, y: 0, w: 6, h: 3, i: '1', key: 'order', id: 1, minH: 3, minW: 4, component: 'PendingOrder' },
  { x: 0, y: 1, w: 5, h: 6, i: '3', key: 'calendar', id: 2, minH: 6, minW: 4, component: 'Calendar' },
  { x: 2, y: 1, w: 6, h: 4, i: '2', key: 'alarm', id: 3, minH: 4, minW: 6, component: 'PageThree' },
  { x: 2, y: 2, w: 5, h: 3, i: '4', key: 'spare', id: 4, minH: 3, minW: 4, component: 'PageOne' },
  // { x: 0, y: 3, w: 5, h: 3, i: '5', key: 'inspect', id: 5, minH: 3, minW: 4, component: 'PageFour' },
  // { x: 2, y: 3, w: 5, h: 3, i: '6', key: 'remind', id: 6, minH: 3, minW: 4, component: 'PageTwo' },
  { x: 2, y: 3, w: 5, h: 3, i: '7', key: 'defRegister', id: 7, minH: 3, minW: 6, component: 'DefRegister' }, //待处理缺陷
  { x: 2, y: 3, w: 5, h: 3, i: '8', key: 'overhaul', id: 8, minH: 3, minW: 6, component: 'Overhaul' }, //待处理检修
]
const defaultBenchData = {
  QuickMenu: { status: 0, title: '快捷菜单', router: '', desc: '-', img: '' },
  PendingOrder: { status: 0, title: '待办工单', router: 'process-upcoming', desc: '-', img: '' },
  Calendar: { status: 0, title: '保养日历', router: 'maintenance-task', desc: '-', img: '' },
  PageThree: { status: 0, title: '未处理告警', router: 'alert-center', desc: '-', img: '' },
  PageOne: { status: 0, title: '备件库存预警', router: 'bp-leadout', desc: '-', img: '' },
  PageFour: { status: 0, title: '智能巡检', router: 'patrol-itrecord', desc: '-', img: '' },
  PageTwo: { status: 0, title: '设备切换提醒', router: 'equipment-switch', desc: '-', img: '' },
  DefRegister: { status: 0, title: '待处理缺陷', router: 'defect-defRegister', desc: '-', img: '' },
  Overhaul: { status: 0, title: '待处理检修', router: 'maintain-overhaul', desc: '-', img: '' },
  WaterRecord: { status: 0, title: '加水记录', router: 'cosumer-record', desc: '-', img: '' },
  ViolationRecord: { status: 0, title: '违规事件', router: 'wf-violations', desc: '-', img: '' }
}
const workbench = {
  state: {
    benchData: null,
    layoutList: [],
    routeList: []
  },
  mutations: {
    SET_BENCH_DATA: (state, data) => {
      state.benchData = data
    },
    SET_LAYOUT_LIST: (state, list) => {
      state.layoutList = list
    },
    SET_ROUTE_LIST: (state, list) => {
      state.routeList = list
    }
  },
  actions: {
    async InitWorkbench({ commit, state, rootState}, data) {
      const { result } = await getAction('/custom/sysUserComponent/list')
      const records = result?.records || []

      // 根据 userInfo.thirdAccount 决定使用哪个 layoutList
      let currentLayoutList = defaultLayoutList
      if (rootState.user.info.thirdAccount === 1) {
        currentLayoutList = [...defaultLayoutList.slice(0, 3)]
      }

      const benchDataMap = currentLayoutList.reduce((pre, cur) => {
        pre.set(cur.component, { data: cur, ...defaultBenchData[cur.component] })
        return pre
      }, new Map())

      // const benchDataMap = defaultLayoutList.reduce((pre, cur) => {
      //   pre.set(cur.component, { data: cur, ...defaultBenchData[cur.component] })
      //   return pre
      // }, new Map())

      const keyItem = records.map(item => {
        return item.componentName
      })

      const resultLayoutList = records.reduce((pre, cur) => {
        const map = benchDataMap.get(cur.componentName) || {};
        pre.push({ ...JSON.parse(cur.componentData), router: map.router })
        benchDataMap.set(cur.componentName, {
          ...map,
          id: cur.id,

          status: keyItem.includes(cur.componentName) ? 1 : 0
        })
        return pre
      }, [])

      commit('SET_LAYOUT_LIST', resultLayoutList)
      commit('SET_BENCH_DATA', benchDataMap)
    },
    stashLayoutItem({ commit, dispatch, state }, listItem) {
      // const layoutList = _.cloneDeep(state.layoutList)
      // const itemIndex = layoutList.findIndex(item => listItem.component === item.component)
      // if (itemIndex !== -1) {
      //   layoutList[itemIndex] = listItem
      // } else {
      //   layoutList.push(listItem)
      // }
      // commit('SET_LAYOUT_LIST', layoutList)
      dispatch('InitWorkbench')
    }
  }
}

export default workbench
